import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import {
  RepasseSetorialDetailsState,
  RepasseSetorialDetailsAction,
  RepasseSetorialDetailsReducer,
} from './repasse-setorial-details-reducer';

const initialState: RepasseSetorialDetailsState = {
  repasseSetorialDetails: null,
  loading: false,
  error: null,
};

const RepasseSetorialDetailsStateContext = createContext<RepasseSetorialDetailsState | undefined>(undefined);
const RepasseSetorialDetailsDispatchContext = createContext<React.Dispatch<RepasseSetorialDetailsAction> | undefined>(undefined);

interface RepasseSetorialDetailsProviderProps {
  children: ReactNode;
}

export const RepasseSetorialDetailsProvider: React.FC<RepasseSetorialDetailsProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(RepasseSetorialDetailsReducer, initialState);

  return (
    <RepasseSetorialDetailsStateContext.Provider value={state}>
      <RepasseSetorialDetailsDispatchContext.Provider value={dispatch}>
        {children}
      </RepasseSetorialDetailsDispatchContext.Provider>
    </RepasseSetorialDetailsStateContext.Provider>
  );
};

export const useRepasseSetorialDetailsState = (): RepasseSetorialDetailsState => {
  const context = useContext(RepasseSetorialDetailsStateContext);
  if (context === undefined) {
    throw new Error('useRepasseSetorialDetailsState must be used within a RepasseSetorialDetailsProvider');
  }
  return context;
};

export const useRepasseSetorialDetailsDispatch = (): React.Dispatch<RepasseSetorialDetailsAction> => {
  const context = useContext(RepasseSetorialDetailsDispatchContext);
  if (context === undefined) {
    throw new Error('useRepasseSetorialDetailsDispatch must be used within a RepasseSetorialDetailsProvider');
  }
  return context;
};
